import { ErrorReference } from '../../types';

export const SUBSCRIPTION_NOT_FOUND: ErrorReference = {
  server: {
    error_type: 'CRA_MONITORING_ERROR',
    error_code: 'SUBSCRIPTION_NOT_FOUND',
    error_message: 'no subscription found for the subscription id provided.',
    display_message: null,
    http_code: 404,
  },
  link: null,
};

export const SUBSCRIPTION_ALREADY_EXISTS: ErrorReference = {
  server: {
    error_type: 'CRA_MONITORING_ERROR',
    error_code: 'SUBSCRIPTION_ALREADY_EXISTS',
    error_message:
      'there already exists a subscription for the given user token.',
    display_message: null,
    http_code: 400,
  },
  link: null,
};

export const SUBSCRIPTION_LIMIT_EXCEEDED: ErrorReference = {
  server: {
    error_type: 'CRA_MONITORING_ERROR',
    error_code: 'SUBSCRIPTION_LIMIT_EXCEEDED',
    error_message:
      'the provided user token has reached the maximum allowed number of active CRA Servicing subscriptions.',
    display_message: null,
    http_code: 400,
  },
  link: null,
};
